

export const CHAIN_CONFIG = [
  {
    chainId: 501,
    key: 'solana',
    icon: "/img/sol.svg",
    name: 'SOLANA',
    deployUrl: "https://slerf.tools/{{lang}}",
    isHot: true,
  },
  {
    chainId: 56,
    key: 'bsc',
    icon: "/img/chains/bsc.svg",
    name: 'BSC',
    deployUrl: "https://slerf.tools/{{lang}}/bsc",
    isHot: true,
  },
  {
    chainId: 1,
    key: 'ethereum',
    icon: "/img/chains/eth.svg",
    name: 'Ethereum',
    deployUrl: "https://eth.slerf.tools/{{lang}}/ethereum",
    isHot: true,
  },
  {
    chainId: 8453,
    key: 'base',
    icon: "/img/chains/base.webp",
    name: 'BASE',
    deployUrl: "https://base.slerf.tools/{{lang}}",
    isHot: true,
  },
  {
    chainId: 196,
    key: 'xlayer',
    icon: "/img/chains/xlayer.svg",
    name: 'XLayer',
    deployUrl: "https://slerf.tools/{{lang}}/x-layer",
    isHot: true,
  },
  {
    chainId: 9745,
    key: 'plasma',
    icon: "/img/chains/plasma.svg",
    name: 'Plasma',
    deployUrl: "https://slerf.tools/{{lang}}/plasma",
    isHot: false,
  },
  {
    chainId: 728126428,
    key: 'tron',
    icon: "/img/chains/tron.svg",
    name: 'TRON',
    deployUrl: "https://tron.slerf.tools",
    isHot: false,
  },
  {
    chainId: 607,
    key: 'ton',
    icon: "/img/chains/ton.svg",
    name: 'TON',
    deployUrl: "https://ton.slerf.tools/{{lang}}",
    isHot: false,
  },
  {
    chainId: 0,
    key: 'sui',
    icon: "/img/chains/sui.png",
    name: 'SUI',
    deployUrl: "https://sui.slerf.tools/{{lang}}",
    isHot: false,
  }
]